import { FC, useState, createContext } from 'react';

type SidebarContext = {
  /** Mobile drawer open state. */
  sidebarToggle: any;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  /** Desktop sidebar shows icons only. */
  collapsed: boolean;
  toggleCollapsed: () => void;
};

const COLLAPSED_KEY = 'luma.sidebarCollapsed';

function readCollapsed(): boolean {
  try {
    return window.localStorage.getItem(COLLAPSED_KEY) === '1';
  } catch {
    return false;
  }
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SidebarContext = createContext<SidebarContext>(
  {} as SidebarContext
);

export const SidebarProvider: FC = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [collapsed, setCollapsed] = useState<boolean>(readCollapsed);

  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };
  const toggleCollapsed = () => {
    setCollapsed((current) => {
      const next = !current;
      try {
        window.localStorage.setItem(COLLAPSED_KEY, next ? '1' : '0');
      } catch {
        // Preference is optional; ignore blocked storage.
      }
      return next;
    });
  };

  return (
    <SidebarContext.Provider
      value={{ sidebarToggle, toggleSidebar, closeSidebar, collapsed, toggleCollapsed }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
